import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { UnhandledErrorCard as CompiledUnhanldedErrorCard } from './unhandledErrorCard-compiled';
import { UnhandledErrorCard as EmotionUnhanldedErrorCard } from './unhandledErrorCard-emotion';
export var UnhandledErrorCard = function UnhandledErrorCard(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledUnhanldedErrorCard, props) : /*#__PURE__*/React.createElement(EmotionUnhanldedErrorCard, props);
};